import { onceVisible } from "./observers.js";
import { onceGuard } from "./bind_once.js";

const firstBind = onceGuard();

const DURATION_MS = 1100;

function parseStatValue(raw) {
  const match = raw.match(/^([^\d-]*)(-?[\d,]+(?:\.\d+)?)(.*)$/);
  if (!match) return null;
  const numeric = Number.parseFloat(match[2].replace(/,/g, ""));
  if (!Number.isFinite(numeric)) return null;
  return {
    prefix: match[1],
    suffix: match[3],
    value: numeric,
    hasComma: /,/.test(match[2]),
    decimals: (match[2].split(".")[1] || "").length,
  };
}

function formatNumber(n, hasComma, decimals) {
  const fixed = decimals > 0 ? n.toFixed(decimals) : Math.round(n).toString();
  if (!hasComma) return fixed;
  const [intPart, decPart] = fixed.split(".");
  const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return decPart ? `${withCommas}.${decPart}` : withCommas;
}

function animate(el) {
  const raw = el.dataset.statValue ?? el.textContent ?? "";
  const parsed = parseStatValue(raw);
  if (!parsed) return;

  const prefersReduced = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  if (prefersReduced) {
    el.textContent = raw;
    return;
  }

  const { prefix, suffix, value, hasComma, decimals } = parsed;
  const start = performance.now();

  const tick = (now) => {
    const t = Math.min(1, (now - start) / DURATION_MS);
    const eased = 1 - Math.pow(1 - t, 3);
    const current = value * eased;
    el.textContent = `${prefix}${formatNumber(current, hasComma, decimals)}${suffix}`;
    if (t < 1) requestAnimationFrame(tick);
    else el.textContent = raw;
  };

  requestAnimationFrame(tick);
}

export function initCountUp(root = document) {
  const scope =
    root instanceof Document ? root : root.ownerDocument || document;
  const stats = [
    ...scope.querySelectorAll(".stat-countup[data-stat-value]"),
  ].filter(firstBind);
  // A region marked data-countup-off shows its values as they are: a
  // filter swap should read instantly, not replay the entrance.
  onceVisible(
    stats.filter((el) => !el.closest("[data-countup-off]")),
    animate,
  );
}
